var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('img',_vm._g({staticClass:"pl-1",attrs:{"src":require("@Assets/icons/first.svg"),"alt":"","width":"20"}},on))]}}])},[_c('span',[_vm._v("Primeira Box")])])}
var staticRenderFns = []

export { render, staticRenderFns }